import { Card, Flexbox } from '@/components'
import { textClasses } from '@/constants/castration'
import { ANIMAL, CASTRATION } from '@/lib/enums'
import PropTypes from 'prop-types'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function CastrationsCard({ castrations }) {
  const { pathname } = useLocation()

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Castrações por categoria</div>
            <cite>5 categorias com maior número de castrações</cite>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-cut" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        {castrations?.length ? (
          <table className="table text-small table-striped table-hover">
            <thead>
              <tr>
                <th width={300}>Gênero</th>
                <th width={300}>Status</th>
                <th width={300}>Espécie</th>
                <th className="text-right" width={100}>
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {Boolean(castrations?.length)
                && castrations.map((castration) => (
                  <tr
                    key={`${castration?.gender}-${castration?.status}
                    -${castration?.categoryDescription}`}
                  >
                    <td>{ANIMAL.gender.t(castration?.gender)}</td>
                    <td className={textClasses[castration?.status]}>
                      {CASTRATION.status.t(castration?.status)}
                    </td>
                    <td>{castration?.categoryDescription}</td>
                    <td className="text-right">{castration?.total}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>Esse usuário não possui castrações vinculadas</div>
        )}
      </Card.Body>
      <Card.Footer className="text-right">
        <Link to={`${pathname}/castrations`} className="btn btn-sm btn-primary">
          <i className="fas fa-folder-open" />
          &nbsp;Ver tudo
        </Link>
      </Card.Footer>
    </Card.Base>
  )
}

CastrationsCard.propTypes = {
  castrations: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default CastrationsCard
